module.exports = __webpack_public_path__ + "static/media/SN.010dc497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SN.svg
// module id = 2263
// module chunks = 7